import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ThemeToggle } from './ThemeToggle';
import { api } from '../services/api';
import clsx from 'clsx';

// Icons
const DashboardIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
  </svg>
);

const OrdersIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const ProductionIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
  </svg>
);

const DealersIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
);

const InventoryIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
  </svg>
);

const BomIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
  </svg>
);

const ReportsIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
  </svg>
);

const SettingsIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const MenuIcon = () => (
  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

const CloseIcon = () => (
  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
);

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  icon: React.ReactNode;
  onClick?: () => void;
  customClassName?: string;
}

function NavLink({ to, children, icon, onClick, customClassName }: NavLinkProps) {
  const location = useLocation();
  const isActive = to === '/'
    ? location.pathname === '/'
    : location.pathname.startsWith(to);

  return (
    <Link
      to={to}
      onClick={onClick}
      className={clsx(
        'flex items-center gap-3 px-4 py-3 rounded-lg transition-colors',
        isActive
          ? 'bg-blue-600 text-white'
          : customClassName || 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
      )}
    >
      {icon}
      <span className="font-medium">{children}</span>
    </Link>
  );
}

const UsersIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
  </svg>
);

const WarrantyIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
);

const SalesIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const ShippingIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
  </svg>
);

const OverviewIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
  </svg>
);

const HRIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const UserDeletionIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);

const ManufacturingIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const AnalyticsIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
  </svg>
);

const CalendarIcon = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

// Standalone nav items (non-dropdown)
const standaloneItems = {
  dashboard: { to: '/', label: 'Dashboard', icon: <DashboardIcon /> },
  shipping: { to: '/shipping', label: 'Shipping', icon: <ShippingIcon /> },
  inventory: { to: '/inventory', label: 'Inventory', icon: <InventoryIcon /> },
  bom: { to: '/bom', label: 'BOM', icon: <BomIcon /> },
  dealers: { to: '/dealers', label: 'Dealers', icon: <DealersIcon /> },
  reports: { to: '/reports', label: 'Reports', icon: <ReportsIcon /> },
};

export function Layout({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [ordersMenuOpen, setOrdersMenuOpen] = useState(
    location.pathname.startsWith('/orders') ||
    location.pathname.startsWith('/special-orders') ||
    location.pathname.startsWith('/order-overview') ||
    location.pathname.startsWith('/production') ||
    location.pathname.startsWith('/backorders')
  );
  const [userManagementMenuOpen, setUserManagementMenuOpen] = useState(
    location.pathname.startsWith('/users')
  );
  const [warrantyMenuOpen, setWarrantyMenuOpen] = useState(
    location.pathname.startsWith('/warranty')
  );
  const [hrMenuOpen, setHrMenuOpen] = useState(
    location.pathname.startsWith('/hr')
  );
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(
    location.pathname.startsWith('/settings')
  );
  const [reportsMenuOpen, setReportsMenuOpen] = useState(
    location.pathname.startsWith('/reports') || location.pathname.startsWith('/analytics')
  );
  const [dealersMenuOpen, setDealersMenuOpen] = useState(
    location.pathname.startsWith('/dealers') || location.pathname.startsWith('/accounting/approvals')
  );
  const [accountingMenuOpen, setAccountingMenuOpen] = useState(
    location.pathname.startsWith('/accounting') || location.pathname === '/sales'
  );
  const [canViewCostAnalytics, setCanViewCostAnalytics] = useState(false);
  const [pendingAppsCount, setPendingAppsCount] = useState(0);
  const [supportAttentionCount, setSupportAttentionCount] = useState(0);
  const [supportRequestsNewCount, setSupportRequestsNewCount] = useState(0);
  const [shortageCount, setShortageCount] = useState(0);
  const [qbPendingCount, setQbPendingCount] = useState(0);
  const [correctionCount, setCorrectionCount] = useState(0);
  const [invoiceModifiedCount, setInvoiceModifiedCount] = useState(0);
  const [taxFilingAlert, setTaxFilingAlert] = useState<{
    filingDueCount: number; overdueCount: number; paymentDueTotal: number; nextDueDate: string | null;
  }>({ filingDueCount: 0, overdueCount: 0, paymentDueTotal: 0, nextDueDate: null });

  const isAccountingOnly = user?.allowed_portals?.includes('accounting') &&
                           !user?.allowed_portals?.includes('factory');

  // Check cost analytics permission
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const checkCostPermission = async () => {
      try {
        const result = await api.costAccounting.canView();
        setCanViewCostAnalytics(result.canView);
      } catch (error) {
        setCanViewCostAnalytics(false);
      }
    };
    if (user) {
      checkCostPermission();
    }
  }, [user]);

  // Fetch pending dealer applications count + inventory shortages
  useEffect(() => {
    const fetchPendingCount = async () => {
      try {
        const data = await api.accounting.getDashboard();
        setPendingAppsCount(data.pending_applications || 0);
      } catch (error) {
        // Non-critical — silently fail
      }
    };
    const fetchShortageCount = async () => {
      try {
        const data = await api.production.getShortageSummary();
        setShortageCount(data.totalShortageItems || 0);
      } catch (error) {
        // Non-critical — silently fail
      }
    };
    const fetchSupportAttention = async () => {
      try {
        const s = await api.support.stats(7);
        const unassigned = parseInt(s.summary?.unassigned_count || '0', 10);
        const stale = parseInt(s.summary?.stale_count || '0', 10);
        setSupportAttentionCount(Math.max(unassigned, stale));
      } catch (error) {
        // Non-critical — silently fail
      }
    };
    const fetchSupportRequestsNew = async () => {
      try {
        const token = localStorage.getItem('admin_auth_token');
        const API_BASE = import.meta.env.VITE_API_URL || '/api';
        const res = await fetch(`${API_BASE}/support-requests/counts`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok) return; // 403 for users without the permission — silently skip
        const data = await res.json();
        setSupportRequestsNewCount(data.new || 0);
      } catch (error) {
        // Non-critical — silently fail
      }
    };
    const fetchQBCount = async () => {
      try {
        const token = localStorage.getItem('admin_auth_token');
        const API_BASE = import.meta.env.VITE_API_URL || '/api';
        // Use the stats from any order query to get QB counts
        const res = await fetch(`${API_BASE}/orders?limit=1`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok) throw new Error('Failed');
        const data = await res.json();
        const needsEntry = data.stats?.needsQbEntry || 0;
        const needsAdj = data.stats?.needsQbAdjustment || 0;
        setQbPendingCount(needsEntry + needsAdj);
        setInvoiceModifiedCount(data.stats?.invoiceModified || 0);
      } catch (error) {
        console.error('QB count fetch failed:', error);
      }
    };
    const fetchCorrectionCount = async () => {
      try {
        const token = localStorage.getItem('admin_auth_token');
        const API_BASE = import.meta.env.VITE_API_URL || '/api';
        const res = await fetch(`${API_BASE}/orders?status=needs_correction&limit=100`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok) throw new Error('Failed');
        const data = await res.json();
        const items = data.data || data.items || [];
        setCorrectionCount(items.length);
      } catch (error) {
        console.error('Correction count fetch failed:', error);
      }
    };
    const fetchTaxFilingAlert = async () => {
      try {
        const a = await api.tax.filingAlert();
        setTaxFilingAlert({
          filingDueCount: a.filingDueCount || 0,
          overdueCount: a.overdueCount || 0,
          paymentDueTotal: a.paymentDueTotal || 0,
          nextDueDate: a.nextDueDate || null,
        });
      } catch (error) {
        // Non-critical (e.g. non-accounting user) — silently fail
      }
    };
    if (user) {
      fetchPendingCount();
      fetchShortageCount();
      fetchQBCount();
      fetchCorrectionCount();
      fetchSupportAttention();
      fetchSupportRequestsNew();
      fetchTaxFilingAlert();
      const interval = setInterval(() => {
        fetchPendingCount();
        fetchShortageCount();
        fetchQBCount();
        fetchCorrectionCount();
        fetchSupportAttention();
        fetchSupportRequestsNew();
        fetchTaxFilingAlert();
      }, 5 * 60 * 1000);
      return () => clearInterval(interval);
    }
  }, [user]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={clsx(
        'fixed top-0 left-0 z-50 h-full w-64 bg-white border-r border-gray-200 transform transition-transform lg:translate-x-0 flex flex-col',
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      )}>
        {/* Logo */}
        <div className="h-16 flex items-center justify-between px-4 border-b border-gray-200 flex-shrink-0">
          <div className="flex items-center gap-2">
            <img
              src="https://kederscreens.com/wp-content/uploads/2025/07/Keder-logos-1-scaled.png"
              alt="Keder"
              className="h-8 w-auto"
            />
          </div>
          <button
            onClick={() => setSidebarOpen(false)}
            className="lg:hidden p-1 text-gray-500 hover:text-gray-700"
          >
            <CloseIcon />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto sidebar-nav">
          {!isAccountingOnly && (
            <>
              {/* Dashboard */}
              <NavLink
                to={standaloneItems.dashboard.to}
                icon={standaloneItems.dashboard.icon}
                onClick={() => setSidebarOpen(false)}
              >
                {standaloneItems.dashboard.label}
              </NavLink>

              {/* Company Calendar */}
              <NavLink
                to="/calendar"
                icon={<CalendarIcon />}
                onClick={() => setSidebarOpen(false)}
              >
                Company Calendar
              </NavLink>

              {/* Orders Dropdown */}
              <div>
                <button
                  onClick={() => setOrdersMenuOpen(!ordersMenuOpen)}
                  className={clsx(
                    'flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors',
                    (location.pathname.startsWith('/orders') ||
                     location.pathname.startsWith('/order-overview') ||
                     location.pathname.startsWith('/production') ||
                     location.pathname.startsWith('/special-orders') ||
                     location.pathname.startsWith('/backorders'))
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  )}
                >
                  <div className="flex items-center gap-3">
                    <OrdersIcon />
                    <span className="font-medium">Orders</span>
                    {!ordersMenuOpen && (correctionCount > 0 || qbPendingCount > 0) && (
                      <div className="flex items-center gap-1">
                        {correctionCount > 0 && (
                          <span className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-red-500 text-white animate-pulse">{correctionCount}</span>
                        )}
                        {qbPendingCount > 0 && (
                          <span className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-orange-500 text-white animate-pulse">QB {qbPendingCount}</span>
                        )}
                      </div>
                    )}
                  </div>
                  <span className={clsx('transition-transform', ordersMenuOpen && 'rotate-180')}>
                    <ChevronDownIcon />
                  </span>
                </button>
                {ordersMenuOpen && (
                  <div className="ml-8 mt-1 space-y-1">
                    <Link
                      to="/orders"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'flex items-center justify-between px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/orders'
                          ? 'bg-blue-100 text-blue-700'
                          : correctionCount > 0
                            ? 'text-red-700 bg-red-50 hover:bg-red-100 border border-red-200'
                            : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      <span>Active Orders</span>
                      {correctionCount > 0 && (
                        <span className={clsx(
                          'px-1.5 py-0.5 text-[10px] font-bold rounded-full',
                          location.pathname === '/orders'
                            ? 'bg-red-500 text-white'
                            : 'bg-red-500 text-white animate-pulse'
                        )} title={`${correctionCount} orders need correction`}>
                          {correctionCount}
                        </span>
                      )}
                    </Link>
                    <Link
                      to="/order-overview"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'flex items-center justify-between px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/order-overview'
                          ? 'bg-blue-100 text-blue-700'
                          : qbPendingCount > 0
                            ? 'text-orange-700 bg-orange-50 hover:bg-orange-100 border border-orange-200'
                            : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      <span>All Orders</span>
                      {qbPendingCount > 0 && (
                        <span className={clsx(
                          'px-1.5 py-0.5 text-[10px] font-bold rounded-full',
                          location.pathname === '/order-overview'
                            ? 'bg-orange-500 text-white'
                            : 'bg-orange-500 text-white animate-pulse'
                        )} title={`${qbPendingCount} orders need QuickBooks entry`}>
                          QB {qbPendingCount}
                        </span>
                      )}
                    </Link>
                    <Link
                      to="/orders/completed"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/orders/completed'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Completed Orders
                    </Link>
                    <Link
                      to="/production"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/production'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Production
                    </Link>
                    <Link
                      to="/production/floor"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/production/floor'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Production Floor
                    </Link>
                    <Link
                      to="/special-orders"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/special-orders'
                          ? 'bg-purple-100 text-purple-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Special Orders
                    </Link>
                    <Link
                      to="/backorders"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/backorders'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Back-Orders
                    </Link>
                  </div>
                )}
              </div>

              {/* Shipping */}
              <NavLink
                to={standaloneItems.shipping.to}
                icon={standaloneItems.shipping.icon}
                onClick={() => setSidebarOpen(false)}
              >
                {standaloneItems.shipping.label}
              </NavLink>

              {/* Inventory */}
              <NavLink
                to={standaloneItems.inventory.to}
                icon={standaloneItems.inventory.icon}
                onClick={() => setSidebarOpen(false)}
              >
                {standaloneItems.inventory.label}
              </NavLink>

              {/* Purchase Orders */}
              <NavLink
                to="/purchase-orders"
                icon={
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                }
                onClick={() => setSidebarOpen(false)}
              >
                Purchase Orders
              </NavLink>

              {/* What to Order — always visible with shortage badge */}
              <Link
                to="/what-to-order"
                onClick={() => setSidebarOpen(false)}
                className={clsx(
                  'flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors',
                  location.pathname === '/what-to-order'
                    ? 'bg-red-600 text-white'
                    : shortageCount > 0
                      ? 'bg-red-50 text-red-700 hover:bg-red-100 border border-red-200'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                )}
              >
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                  <span className="font-medium">What to Order</span>
                </div>
                {shortageCount > 0 && (
                  <span className={clsx(
                    'px-2 py-0.5 text-xs font-bold rounded-full',
                    location.pathname === '/what-to-order'
                      ? 'bg-white text-red-600'
                      : 'bg-red-500 text-white animate-pulse'
                  )}>
                    {shortageCount}
                  </span>
                )}
              </Link>

              {/* Bins */}
              <NavLink
                to="/bins"
                icon={
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                  </svg>
                }
                onClick={() => setSidebarOpen(false)}
              >
                Bins
              </NavLink>

              {/* Labels */}
              <NavLink
                to="/labels"
                icon={
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                  </svg>
                }
                onClick={() => setSidebarOpen(false)}
              >
                Labels
              </NavLink>

              {/* BOM */}
              <NavLink
                to={standaloneItems.bom.to}
                icon={standaloneItems.bom.icon}
                onClick={() => setSidebarOpen(false)}
              >
                {standaloneItems.bom.label}
              </NavLink>

              {/* Dealers Dropdown */}
              <div>
                <button
                  onClick={() => setDealersMenuOpen(!dealersMenuOpen)}
                  className={clsx(
                    'flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors',
                    (location.pathname.startsWith('/dealers') || location.pathname.startsWith('/accounting/approvals'))
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  )}
                >
                  <div className="flex items-center gap-3">
                    <DealersIcon />
                    <span className="font-medium">Dealers</span>
                    {!dealersMenuOpen && pendingAppsCount > 0 && (
                      <span title="Dealer applications pending" className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-orange-500 text-white animate-pulse">{pendingAppsCount}</span>
                    )}
                    {!dealersMenuOpen && supportAttentionCount > 0 && (
                      <span title="Support tickets need attention" className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-amber-500 text-white animate-pulse">{supportAttentionCount}</span>
                    )}
                  </div>
                  <span className={clsx('transition-transform', dealersMenuOpen && 'rotate-180')}>
                    <ChevronDownIcon />
                  </span>
                </button>
                {dealersMenuOpen && (
                  <div className="ml-8 mt-1 space-y-1">
                    <Link
                      to="/dealers"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/dealers'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      All Dealers
                    </Link>
                    <Link
                      to="/accounting/approvals/dealers"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'flex items-center justify-between px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname.startsWith('/accounting/approvals/dealers')
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      <span>Dealer Applications</span>
                      {pendingAppsCount > 0 && (
                        <span className="px-2 py-0.5 text-xs font-bold rounded-full bg-red-500 text-white">
                          {pendingAppsCount}
                        </span>
                      )}
                    </Link>
                    <Link
                      to="/marketing"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/marketing'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Marketing
                    </Link>
                    <Link
                      to="/lead-distribution"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/lead-distribution'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Lead Distribution
                    </Link>
                    <Link
                      to="/dealers/rewards"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/dealers/rewards'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Rewards
                    </Link>
                    <Link
                      to="/dealers/training"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/dealers/training'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Training Modules
                    </Link>
                    <Link
                      to="/support"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'flex items-center justify-between px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname.startsWith('/support')
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      <span>Support Tickets</span>
                      {supportAttentionCount > 0 && (
                        <span className="px-2 py-0.5 text-xs font-bold rounded-full bg-amber-500 text-white">
                          {supportAttentionCount}
                        </span>
                      )}
                    </Link>
                  </div>
                )}
              </div>

              {/* User Management Dropdown */}
              <div>
                <button
                  onClick={() => setUserManagementMenuOpen(!userManagementMenuOpen)}
                  className={clsx(
                    'flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors',
                    location.pathname.startsWith('/users')
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  )}
                >
                  <div className="flex items-center gap-3">
                    <UsersIcon />
                    <span className="font-medium">User Management</span>
                  </div>
                  <span className={clsx('transition-transform', userManagementMenuOpen && 'rotate-180')}>
                    <ChevronDownIcon />
                  </span>
                </button>
                {userManagementMenuOpen && (
                  <div className="ml-8 mt-1 space-y-1">
                    <Link
                      to="/users"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/users'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      User Management
                    </Link>
                    <Link
                      to="/users/deletion"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors text-red-600 hover:text-red-700 hover:bg-red-50',
                        location.pathname === '/users/deletion'
                          ? 'bg-red-100 text-red-700'
                          : ''
                      )}
                    >
                      User Deletion
                    </Link>
                  </div>
                )}
              </div>

              {/* Warranty Menu */}
              <div>
                <button
                  onClick={() => setWarrantyMenuOpen(!warrantyMenuOpen)}
                  className={clsx(
                    'flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors',
                    location.pathname.startsWith('/warranty')
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  )}
                >
                  <div className="flex items-center gap-3">
                    <WarrantyIcon />
                    <span className="font-medium">Warranty</span>
                  </div>
                  <span className={clsx('transition-transform', warrantyMenuOpen && 'rotate-180')}>
                    <ChevronDownIcon />
                  </span>
                </button>
                {warrantyMenuOpen && (
                  <div className="ml-8 mt-1 space-y-1">
                    <Link
                      to="/warranty/registrations"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/warranty/registrations'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Registrations
                    </Link>
                    <Link
                      to="/warranty/rma-queue"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/warranty/rma-queue'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      RMA Queue
                    </Link>
                    <Link
                      to="/warranty/rma-history"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/warranty/rma-history'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      RMA History
                    </Link>
                  </div>
                )}
              </div>

              {/* HR & Employees Menu */}
              <div>
                <button
                  onClick={() => setHrMenuOpen(!hrMenuOpen)}
                  className={clsx(
                    'flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors',
                    location.pathname.startsWith('/hr')
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  )}
                >
                  <div className="flex items-center gap-3">
                    <HRIcon />
                    <span className="font-medium">HR & Employees</span>
                  </div>
                  <span className={clsx('transition-transform', hrMenuOpen && 'rotate-180')}>
                    <ChevronDownIcon />
                  </span>
                </button>
                {hrMenuOpen && (
                  <div className="ml-8 mt-1 space-y-1">
                    <Link
                      to="/hr"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/hr'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Dashboard
                    </Link>
                    <Link
                      to="/hr/time"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/hr/time'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Time Management
                    </Link>
                    <Link
                      to="/hr/crosschex"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/hr/crosschex'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      CrossChex Sync
                    </Link>
                    <Link
                      to="/hr/training"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/hr/training'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Training
                    </Link>
                    <Link
                      to="/hr/documents"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/hr/documents'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Documents & SOPs
                    </Link>
                    <Link
                      to="/hr/rewards"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/hr/rewards'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Rewards
                    </Link>
                    <Link
                      to="/hr/payroll"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/hr/payroll'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Payroll
                    </Link>
                    {/* Per-employee grant (User Management); the API enforces it too. */}
                    {(user?.permissions?.discipline_access || user?.permissions?.all_access) && (
                    <Link
                      to="/hr/discipline"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/hr/discipline'
                          ? 'bg-red-100 text-red-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Discipline
                    </Link>
                    )}
                    {/* Separations — tighter grant than discipline; API enforces it too. */}
                    {((user?.permissions as any)?.separation_access || user?.permissions?.all_access) && (
                    <Link
                      to="/hr/separations"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/hr/separations'
                          ? 'bg-red-100 text-red-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Separations
                    </Link>
                    )}
                    {/* Support Requests + Follow-ups — open to any Factory Admin so
                        anyone can add to the shared to-do list; API enforces it too. */}
                    {(user?.permissions?.factory_admin_access || user?.permissions?.all_access) && (
                    <Link
                      to="/hr/support-requests"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'flex items-center justify-between px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/hr/support-requests'
                          ? 'bg-red-100 text-red-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      <span>Support Requests</span>
                      {supportRequestsNewCount > 0 && (
                        <span title="New requests from the floor" className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-red-500 text-white animate-pulse">{supportRequestsNewCount}</span>
                      )}
                    </Link>
                    )}
                    {/* Reviews — its own permission; API enforces it too. */}
                    {((user?.permissions as any)?.reviews_access || user?.permissions?.all_access) && (
                    <Link
                      to="/hr/reviews"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/hr/reviews'
                          ? 'bg-red-100 text-red-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Reviews
                    </Link>
                    )}
                  </div>
                )}
              </div>
            </>
          )}

          {/* Accounting Dropdown — visible if accounting_access or all_access or admin role */}
          {(user?.permissions?.accounting_access || user?.permissions?.all_access || isAccountingOnly || user?.role === 'admin' || user?.role === 'production_manager') && <div>
            <button
              onClick={() => setAccountingMenuOpen(!accountingMenuOpen)}
              className={clsx(
                'flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors',
                (location.pathname.startsWith('/accounting') || location.pathname === '/sales')
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
              )}
            >
              <div className="flex items-center gap-3">
                <SalesIcon />
                <span className="font-medium">Accounting</span>
                {!accountingMenuOpen && invoiceModifiedCount > 0 && (
                  <span className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-amber-500 text-white animate-pulse">
                    {invoiceModifiedCount} edited
                  </span>
                )}
              </div>
              <span className={clsx('transition-transform', accountingMenuOpen && 'rotate-180')}>
                <ChevronDownIcon />
              </span>
            </button>
            {accountingMenuOpen && (
              <div className="ml-8 mt-1 space-y-1">
                <Link
                  to="/sales"
                  onClick={() => setSidebarOpen(false)}
                  className={clsx(
                    'block px-4 py-2 rounded-lg text-sm transition-colors',
                    location.pathname === '/sales'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-100'
                  )}
                >
                  Sales & Commissions
                </Link>
                <Link
                  to="/accounting/expenses/bills"
                  onClick={() => setSidebarOpen(false)}
                  className={clsx(
                    'block px-4 py-2 rounded-lg text-sm transition-colors',
                    location.pathname.startsWith('/accounting/expenses/bills')
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-100'
                  )}
                >
                  Bills
                </Link>
                <Link
                  to="/accounting/credits"
                  onClick={() => setSidebarOpen(false)}
                  className={clsx(
                    'block px-4 py-2 rounded-lg text-sm transition-colors',
                    location.pathname === '/accounting/credits'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-100'
                  )}
                >
                  Credits &amp; Overpayments
                </Link>
                <Link
                  to="/accounting/operating-costs"
                  onClick={() => setSidebarOpen(false)}
                  className={clsx(
                    'block px-4 py-2 rounded-lg text-sm transition-colors',
                    (location.pathname === '/accounting/operating-costs' || location.pathname === '/settings/operating-costs')
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-100'
                  )}
                >
                  Operating Costs
                </Link>
                <Link
                  to="/accounting/employees"
                  onClick={() => setSidebarOpen(false)}
                  className={clsx(
                    'block px-4 py-2 rounded-lg text-sm transition-colors',
                    location.pathname.startsWith('/accounting/employees')
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-100'
                  )}
                >
                  Employee Tax & Address
                </Link>
                <Link
                  to="/accounting/revenue/shipped"
                  onClick={() => setSidebarOpen(false)}
                  className={clsx(
                    'block px-4 py-2 rounded-lg text-sm transition-colors',
                    location.pathname === '/accounting/revenue/shipped'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-100'
                  )}
                >
                  Orders Shipped
                </Link>
                <Link
                  to="/accounting/revenue/payments"
                  onClick={() => setSidebarOpen(false)}
                  className={clsx(
                    'block px-4 py-2 rounded-lg text-sm transition-colors',
                    location.pathname === '/accounting/revenue/payments'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-100'
                  )}
                >
                  Payments Received
                </Link>
                <Link
                  to="/accounting/invoices-adjusted"
                  onClick={() => setSidebarOpen(false)}
                  className={clsx(
                    'flex items-center justify-between px-4 py-2 rounded-lg text-sm transition-colors',
                    location.pathname === '/accounting/invoices-adjusted'
                      ? 'bg-blue-100 text-blue-700'
                      : invoiceModifiedCount > 0
                        ? 'text-amber-700 bg-amber-50 hover:bg-amber-100 border border-amber-200'
                        : 'text-gray-600 hover:bg-gray-100'
                  )}
                >
                  <span>Invoices Adjusted</span>
                  {invoiceModifiedCount > 0 && (
                    <span className={clsx(
                      'px-1.5 py-0.5 text-[10px] font-bold rounded-full',
                      location.pathname === '/accounting/invoices-adjusted'
                        ? 'bg-amber-500 text-white'
                        : 'bg-amber-500 text-white animate-pulse'
                    )} title={`${invoiceModifiedCount} invoices have been adjusted`}>
                      {invoiceModifiedCount}
                    </span>
                  )}
                </Link>
                <Link
                  to="/accounting/write-offs"
                  onClick={() => setSidebarOpen(false)}
                  className={clsx(
                    'block px-4 py-2 rounded-lg text-sm transition-colors',
                    location.pathname === '/accounting/write-offs'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-100'
                  )}
                >
                  Write-offs
                </Link>
                <Link
                  to="/accounting/reports/monthly"
                  onClick={() => setSidebarOpen(false)}
                  className={clsx(
                    'block px-4 py-2 rounded-lg text-sm transition-colors',
                    location.pathname === '/accounting/reports/monthly'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-100'
                  )}
                >
                  Monthly Summary
                </Link>
                {/* QuickBooks — hidden until production keys are configured
                <Link
                  to="/accounting/quickbooks"
                  onClick={() => setSidebarOpen(false)}
                  className={clsx(
                    'block px-4 py-2 rounded-lg text-sm transition-colors',
                    location.pathname === '/accounting/quickbooks'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-100'
                  )}
                >
                  QuickBooks
                </Link>
                */}
              </div>
            )}
          </div>}

          {/* Dealers & User Management for accounting-only users (already shown in main nav for factory users) */}
          {isAccountingOnly && (
            <>
              {/* Dealers Dropdown */}
              <div>
                <button
                  onClick={() => setDealersMenuOpen(!dealersMenuOpen)}
                  className={clsx(
                    'flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors',
                    location.pathname.startsWith('/dealers')
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  )}
                >
                  <div className="flex items-center gap-3">
                    <DealersIcon />
                    <span className="font-medium">Dealers</span>
                    {!dealersMenuOpen && pendingAppsCount > 0 && (
                      <span title="Dealer applications pending" className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-orange-500 text-white animate-pulse">{pendingAppsCount}</span>
                    )}
                    {!dealersMenuOpen && supportAttentionCount > 0 && (
                      <span title="Support tickets need attention" className="px-1.5 py-0.5 text-[10px] font-bold rounded-full bg-amber-500 text-white animate-pulse">{supportAttentionCount}</span>
                    )}
                  </div>
                  <span className={clsx('transition-transform', dealersMenuOpen && 'rotate-180')}>
                    <ChevronDownIcon />
                  </span>
                </button>
                {dealersMenuOpen && (
                  <div className="ml-8 mt-1 space-y-1">
                    <Link
                      to="/dealers"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/dealers'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      All Dealers
                    </Link>
                    <Link
                      to="/accounting/approvals/dealers"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'flex items-center justify-between px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname.startsWith('/accounting/approvals/dealers')
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      <span>Dealer Applications</span>
                      {pendingAppsCount > 0 && (
                        <span className="px-2 py-0.5 text-xs font-bold rounded-full bg-red-500 text-white">
                          {pendingAppsCount}
                        </span>
                      )}
                    </Link>
                    <Link
                      to="/support"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'flex items-center justify-between px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname.startsWith('/support')
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      <span>Support Tickets</span>
                      {supportAttentionCount > 0 && (
                        <span className="px-2 py-0.5 text-xs font-bold rounded-full bg-amber-500 text-white">
                          {supportAttentionCount}
                        </span>
                      )}
                    </Link>
                  </div>
                )}
              </div>

              {/* User Management */}
              <Link
                to="/users"
                onClick={() => setSidebarOpen(false)}
                className={clsx(
                  'flex items-center gap-3 w-full px-4 py-3 rounded-lg transition-colors',
                  location.pathname.startsWith('/users')
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                )}
              >
                <UsersIcon />
                <span className="font-medium">User Management</span>
              </Link>
            </>
          )}

          {!isAccountingOnly && (
            <>
              {/* Reports Dropdown */}
              <div>
                <button
                  onClick={() => setReportsMenuOpen(!reportsMenuOpen)}
                  className={clsx(
                    'flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors',
                    (location.pathname.startsWith('/reports') || location.pathname.startsWith('/analytics'))
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  )}
                >
                  <div className="flex items-center gap-3">
                    <ReportsIcon />
                    <span className="font-medium">Reports</span>
                    {taxFilingAlert.filingDueCount > 0 && (
                      <span
                        title={`${taxFilingAlert.filingDueCount} tax return(s) due${taxFilingAlert.paymentDueTotal > 0 ? ` · $${taxFilingAlert.paymentDueTotal.toLocaleString()} to remit` : ''}`}
                        className={clsx(
                          'px-1.5 py-0.5 text-[10px] font-bold rounded-full text-white animate-pulse',
                          taxFilingAlert.overdueCount > 0 ? 'bg-red-500' : 'bg-amber-500',
                        )}
                      >
                        TAX {taxFilingAlert.filingDueCount}
                      </span>
                    )}
                  </div>
                  <span className={clsx('transition-transform', reportsMenuOpen && 'rotate-180')}>
                    <ChevronDownIcon />
                  </span>
                </button>
                {reportsMenuOpen && (
                  <div className="ml-8 mt-1 space-y-1">
                    <Link
                      to="/reports"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/reports'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      General Reports
                    </Link>
                    <Link
                      to="/reports/inventory"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/reports/inventory'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Inventory Reports
                    </Link>
                    <Link
                      to="/reports/payroll"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/reports/payroll'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Payroll Reports
                    </Link>
                    <Link
                      to="/reports/tax-filings"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'flex items-center justify-between px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/reports/tax-filings'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      <span>Tax Filings (due)</span>
                      {taxFilingAlert.filingDueCount > 0 && (
                        <span
                          title={taxFilingAlert.nextDueDate ? `Due by ${taxFilingAlert.nextDueDate}` : undefined}
                          className={clsx(
                            'ml-2 px-1.5 py-0.5 text-[10px] font-bold rounded-full text-white animate-pulse whitespace-nowrap',
                            taxFilingAlert.overdueCount > 0 ? 'bg-red-500' : 'bg-amber-500',
                          )}
                        >
                          {taxFilingAlert.overdueCount > 0 ? 'OVERDUE' : 'DUE'}
                          {taxFilingAlert.paymentDueTotal > 0 && ` · $${taxFilingAlert.paymentDueTotal.toLocaleString()}`}
                        </span>
                      )}
                    </Link>
                    <Link
                      to="/reports/tax-collected"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/reports/tax-collected'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Tax Collected (history)
                    </Link>
                    <Link
                      to="/reports/purchasing"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/reports/purchasing'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Purchasing Report
                    </Link>
                    <Link
                      to="/reports/nexus"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/reports/nexus'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Economic Nexus Tracker
                    </Link>
                    {canViewCostAnalytics && (
                      <Link
                        to="/analytics/cost"
                        onClick={() => setSidebarOpen(false)}
                        className={clsx(
                          'block px-4 py-2 rounded-lg text-sm transition-colors',
                          location.pathname === '/analytics/cost'
                            ? 'bg-blue-100 text-blue-700'
                            : 'text-gray-600 hover:bg-gray-100'
                        )}
                      >
                        Cost Analytics
                      </Link>
                    )}
                  </div>
                )}
              </div>

              {/* Settings Menu */}
              <div>
                <button
                  onClick={() => setSettingsMenuOpen(!settingsMenuOpen)}
                  className={clsx(
                    'flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors',
                    location.pathname.startsWith('/settings')
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  )}
                >
                  <div className="flex items-center gap-3">
                    <SettingsIcon />
                    <span className="font-medium">Settings</span>
                  </div>
                  <span className={clsx('transition-transform', settingsMenuOpen && 'rotate-180')}>
                    <ChevronDownIcon />
                  </span>
                </button>
                {settingsMenuOpen && (
                  <div className="ml-8 mt-1 space-y-1">
                    <Link
                      to="/settings"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/settings'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      General Settings
                    </Link>
                    <Link
                      to="/settings/manufacturing-rules"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/settings/manufacturing-rules'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Manufacturing Rules
                    </Link>
                    <Link
                      to="/settings/inventory-groups"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/settings/inventory-groups'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Inventory Groups
                    </Link>
                    <Link
                      to="/settings/product-lines"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/settings/product-lines'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Product Lines
                    </Link>
                    <Link
                      to="/settings/fabric-settings"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/settings/fabric-settings'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Fabric Settings
                    </Link>
                    <Link
                      to="/settings/bin-types"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/settings/bin-types'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Bin Types
                    </Link>
                    <Link
                      to="/settings/audit-log"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/settings/audit-log'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Audit Log
                    </Link>
                    {(user?.permissions?.all_access || user?.permissions?.factory_admin_access) && (
                      <Link
                        to="/settings/security"
                        onClick={() => setSidebarOpen(false)}
                        className={clsx(
                          'block px-4 py-2 rounded-lg text-sm transition-colors',
                          location.pathname === '/settings/security'
                            ? 'bg-blue-100 text-blue-700'
                            : 'text-gray-600 hover:bg-gray-100'
                        )}
                      >
                        Security
                      </Link>
                    )}
                    <Link
                      to="/settings/sales-tax-nexus"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/settings/sales-tax-nexus'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Sales Tax & Nexus
                    </Link>
                    <Link
                      to="/settings/workstation-steps"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/settings/workstation-steps'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Workstation Steps
                    </Link>
                    <Link
                      to="/settings/parts-pull-template"
                      onClick={() => setSidebarOpen(false)}
                      className={clsx(
                        'block px-4 py-2 rounded-lg text-sm transition-colors',
                        location.pathname === '/settings/parts-pull-template'
                          ? 'bg-blue-100 text-blue-700'
                          : 'text-gray-600 hover:bg-gray-100'
                      )}
                    >
                      Parts Pull Template
                    </Link>
                  </div>
                )}
              </div>
            </>
          )}
        </nav>

        {/* User section */}
        <div className="flex-shrink-0 p-4 border-t border-gray-200 bg-white sidebar-footer">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold">
              {user?.name?.charAt(0) || 'U'}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">{user?.name}</p>
              <p className="text-xs text-gray-500 capitalize">{user?.role}</p>
            </div>
          </div>
          <div className="flex gap-2">
            <button
              onClick={handleLogout}
              className="flex-1 text-center text-sm text-gray-600 hover:text-gray-900 py-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              Sign out
            </button>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <div className="lg:pl-64">
        {/* Top bar */}
        <header className="h-16 border-b flex items-center px-4 lg:px-8" style={{ backgroundColor: 'var(--bg-card)', borderColor: 'var(--border-color)' }}>
          <button
            onClick={() => setSidebarOpen(true)}
            className="lg:hidden p-2 -ml-2"
            style={{ color: 'var(--text-secondary)' }}
          >
            <MenuIcon />
          </button>
          <div className="flex-1" />
          {/* Theme Toggle */}
          <ThemeToggle defaultDark={false} />
        </header>

        {/* Page content */}
        <main className="p-4 lg:p-8 pb-16">
          {children}
        </main>

        {/* Footer */}
        <footer className="py-4 px-6 border-t border-gray-200 text-center text-xs text-gray-500">
          &copy; {new Date().getFullYear()} Keder Screens | <a href="https://kederscreens.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-700">Terms</a> | <a href="https://kederscreens.com/privacy/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-700">Privacy</a> | <a href="https://kederscreens.com/cookie-policy/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-700">Cookies</a>
        </footer>
      </div>
    </div>
  );
}

// Page components
export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        {subtitle && <p className="text-gray-500 mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </div>
  );
}

export function Card({
  children,
  className,
  title,
  action,
}: {
  children: React.ReactNode;
  className?: string;
  title?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className={clsx('bg-white rounded-xl border border-gray-200 p-6', className)}>
      {(title || action) && (
        <div className="flex items-center justify-between mb-4">
          {title && <h3 className="text-lg font-semibold text-gray-900">{title}</h3>}
          {action && <div>{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
}

export function LoadingSpinner({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <div className={clsx('animate-spin rounded-full border-2 border-gray-200 border-t-blue-600', sizeClasses[size])} />
  );
}

export function LoadingPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <LoadingSpinner size="lg" />
    </div>
  );
}

// Status badge component
export function StatusBadge({ 
  status, 
  variant = 'default' 
}: { 
  status: string; 
  variant?: 'default' | 'order' | 'workorder' | 'dealer';
}) {
  const getStatusColor = () => {
    const statusLower = status.toLowerCase().replace(/_/g, ' ');
    
    // Order statuses
    if (['draft', 'pending', 'pending release'].includes(statusLower)) {
      return 'bg-gray-100 text-gray-700';
    }
    if (['submitted', 'approved'].includes(statusLower)) {
      return 'bg-blue-100 text-blue-700';
    }
    if (['in production'].includes(statusLower)) {
      return 'bg-yellow-100 text-yellow-700';
    }
    if (['ready', 'complete', 'completed'].includes(statusLower)) {
      return 'bg-green-100 text-green-700';
    }
    if (['shipped', 'closed'].includes(statusLower)) {
      return 'bg-purple-100 text-purple-700';
    }
    if (['needs correction'].includes(statusLower)) {
      return 'bg-orange-100 text-orange-700';
    }
    if (['cancelled', 'on hold', 'blocked'].includes(statusLower)) {
      return 'bg-red-100 text-red-700';
    }
    if (['active'].includes(statusLower)) {
      return 'bg-green-100 text-green-700';
    }
    if (['inactive'].includes(statusLower)) {
      return 'bg-gray-100 text-gray-700';
    }
    
    return 'bg-gray-100 text-gray-700';
  };

  return (
    <span className={clsx(
      'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize',
      getStatusColor()
    )}>
      {status.replace(/_/g, ' ')}
    </span>
  );
}

export default Layout;
